import React, { useState } from "react";
import { /*Link,*/ useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Factory from "../../classes/factory";
import useUrls from "../../hooks/useUrls";
import { logUserIn } from "../../store/slices/auth";
import Paths from "../../util/paths";
import TextInput from "../form/TextInput";
import Box from "../layout/Box";
import http from "../../services/httpService";
import { useMutation } from "react-query";
import ButtonSubmit from "../form/ButtonSubmit";
import LogoutMessage from "./LogoutMessage";

const LoginForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const { apiUrl } = useUrls();

  const mutation = useMutation(
    (data) => http.post(`${apiUrl}/users/auth`, data),
    {
      onSuccess: (data) => {
        console.log("mutation success");
        handleLogin(data);
      },
      onError: (error) => {
        setErrorMessage(error.response.data.error);
      },
    }
  );

  const handleLogin = ({ data, headers }) => {
    console.log("handleLogin() called with data:");
    console.log(data);

    dispatch(logUserIn(data.user));
    localStorage.setItem("token", headers["x-auth-token"]);

    redirectUser(data);
  };

  const redirectUser = (data) => {
    if (!data || !data.userInfo) return;

    let { userInfo: userInfoData } = data;
    const factory = new Factory(userInfoData);
    const { userInfo } = factory;

    let leagueObj;
    let leagueSeasonObj;
    let teamObj;
    let season;
    let path;

    const getLeagueObjAndSeasonFromLeagueSeasonObj = (leagueSeasonObj) => {
      leagueObj = userInfo.getLeagueObj(leagueSeasonObj.league);
      season = leagueSeasonObj.season;
      return { leagueObj, season };
    };

    const getLeagueSeasonPath = (leagueObj, season) => {
      let paths = new Paths({ league: leagueObj, season });
      return paths.get("leagueSeasonHome");
    };

    if (userInfo.hasSelectedTeam()) {
      teamObj = userInfo.getSelectedTeamObj();
      if (teamObj.leagueSeason) {
        leagueSeasonObj = userInfo.getLeagueSeasonObj(teamObj.leagueSeason);
        ({ leagueObj, season } =
          getLeagueObjAndSeasonFromLeagueSeasonObj(leagueSeasonObj));
        // set path to league season home
        path = getLeagueSeasonPath(leagueObj, season);
      } else {
        // set path to franchise home
        path = `/teams/${teamObj.franchise}`;
      }
    } else if (userInfo.hasSelectedLeagueSeason()) {
      leagueSeasonObj = userInfo.getSelectedLeagueSeasonObj();
      ({ leagueObj, season } =
        getLeagueObjAndSeasonFromLeagueSeasonObj(leagueSeasonObj));
      // set path to league season home
      path = getLeagueSeasonPath(leagueObj, season);
    } else {
      // set path to user home
      path = new Paths({ username: userInfo.data.user.username }).get(
        "userHome"
      );
    }

    history.replace(path);
  };

  return (
    <Box title={"log in"} id={"login"} boxWidth={"20.25rem"}>
      <LogoutMessage />
      <Formik
        initialValues={{ email: mutation.variables?.email || "", password: "" }}
        validateOnMount={true}
        validationSchema={Yup.object({
          email: Yup.string().required("Required"),
          password: Yup.string().required("Required"),
        })}
        onSubmit={mutation.mutate}
      >
        {({ isValid }) =>
          mutation.isLoading ? (
            <span>Logging you in...</span>
          ) : (
            <>
              {mutation.isError ? (
                <div className={"alert"}>{errorMessage}</div>
              ) : null}
              {
                <Form>
                  <TextInput
                    name={"email"}
                    type={"text"}
                    label={"Username or Email address"}
                  />
                  <TextInput
                    name={"password"}
                    type={"password"}
                    label={"Password"}
                  />
                  <ButtonSubmit label={"Log in"} formIsValid={isValid} />
                  {/*<p>*/}
                  {/*  No account? <Link to={"/sign-up"}>Sign up here</Link>.*/}
                  {/*</p>*/}
                </Form>
              }
            </>
          )
        }
      </Formik>
    </Box>
  );
};

export default LoginForm;
